import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import { transform } from 'ol/proj';

function RechercheLocalisation({ map, setCenter,setCentreAdresse }) {

    const [liste, setListe] = useState([]);
    const [adresse, setAdresse] = useState({});

    const filterOptions = (options, { inputValue }) => {
        return options
    }

    useEffect(() => {
        if (adresse && adresse.x && adresse.y) {
            var point = transform([adresse.x, adresse.y], 'EPSG:4326', 'EPSG:3857');
            setCenter(point);
            setCentreAdresse(point)
            map.getView().setZoom(15);
        }
        // eslint-disable-next-line
    }, [adresse]);

    return <Autocomplete
        className="recherchelocalisation"
        size="small"
        id="combo-box-demo"
        options={liste}
        filterOptions={filterOptions}
        noOptionsText={"Aucune adresses trouvées"}
        onChange={(event, option, reason) => {
            setAdresse(option);
        }}
        //getOptionSelected={(option, value) => option.adressecomplete === value.adressecomplete}
        onInputChange={(event, adresse, reason) => {
            if (adresse.length > 3) {
                fetch('https://api-adresse.data.gouv.fr/search/?q=' + adresse + '&limit=5')
                    .then(response => response.json())
                    .then(data => {
                        if (typeof data.features !== "undefined") {
                            var liste = data.features.map(adresses => {
                                //console.log(adresses)
                                return {
                                    adressecomplete: adresses.properties.label,
                                    commune: adresses.properties.city,
                                    codecommune: adresses.properties.citycode,
                                    adresse: adresses.properties.name,
                                    codepostal: adresses.properties.postcode,
                                    precision: adresses.properties.type,
                                    x: adresses.geometry.coordinates[0],
                                    y: adresses.geometry.coordinates[1],
                                }
                            })
                        }
                        setListe(liste);
                    });
            }
        }
        }
        getOptionLabel={(option) => option.adressecomplete}
        style={{ width: 300 }}
        renderInput={(params) => <TextField {...params}
            label={adresse ? null : "Rechercher une adresse"}
            size="small" />}
    />;
}


export default RechercheLocalisation;

